import React, { useEffect, useRef } from "react";
import anime from "animejs";
import { Mesh, MeshPhongMaterial, BackSide } from "three";

interface RobotProps {
  x: number;
  y: number;
  rotation: number;
  playCount: number;
}
export const Robot: React.FC<RobotProps> = React.memo(
  ({ x, y, rotation, playCount }) => {
    let meshRef = useRef<Mesh>();

    useEffect(() => {
      if (playCount > 0) {
        let mesh = meshRef.current as Mesh;
        let material = mesh.material as MeshPhongMaterial;
        material.opacity = 1;
        anime({
          targets: material,
          opacity: 0,
          duration: 4000,
          easing: "easeOutCubic"
        });
      }
    }, [playCount]);

    return (
      <group position={[x, y, 0.75]} rotation={[0, 0, rotation]}>
        <mesh ref={meshRef}>
          <boxGeometry attach="geometry" args={[0.3, 0.3, 0.6]} />
          <meshPhongMaterial
            attach="material"
            opacity={0}
            color="#8282FF"
            diffuse="#ff0000"
            emissive="#00004d"
            specular="#000000"
            shininess="53"
          />
        </mesh>
        <mesh scale={[1.1, 1.1, 1.1]}>
          <boxGeometry attach="geometry" args={[0.3, 0.3, 0.6]} />
          <meshBasicMaterial attach="material" color="blue" side={BackSide} />
        </mesh>
      </group>
    );
  }
);
